import { Col, Row, Radio } from 'antd';

import React, {  useState } from 'react';
import {isFMPCreatorOrAdministrator} from 'utils/UserInfo';
import ConfirmDialog from '../CommonComponent/DialogBox/ConfirmDialogBox';
import {updateFmpTrackerStatus} from "../../../../api";
import Moment from "moment/moment";

function IpsWorkCompleteSection({
  project,
  history,
  context
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [confirmDialogDetails, setConfirmDialogDetails] = useState({});

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleProjectStatusUpdate = async () => {
    let projectInfo = {
      bpid: project.bpid,
      workOrder: project.workOrder,
      stationName: project.stationName,
      objectId: null,
      fmpDifference: null,
      ipsDifference: null,
      fmpErrorList: []
    };
    const response = await updateFmpTrackerStatus(projectInfo);
    return response ? response : [];
  }

  const handleAllIpsWorkComplete = async (value) => {
    if (value === 'Y' && project.ipsComplFlag === 'N') {
      let response = await handleProjectStatusUpdate();
      if (response.ipsComplFlag === 'Y') {
        history.push(`/dashboard/fmptracker_progress`);
        context.setProjectTab('fmptracker_progress');
        setIsModalOpen(false);
      }
    }
  };
  const handleCompleteProject = (e) => {
    let value = e.target.value;
      setConfirmDialogDetails({
        title: `Do you want to mark ${project.stationName} as a Complete?`,
        confirmButtonName: 'Yes,Complete',
        submitFunctionArgs: value,
        handleSubmit: handleAllIpsWorkComplete,
      });
      setIsModalOpen(true);
  };
  const formatDate = (date) => {
    return Moment(date).format('YYYY-MM-DD HH:mm:ss');
  };

  return (
    <>
      <section className='padding-container'>
        <Row>
          <Col xs={24} sm={24} md={24} lg={12} xl={18}>
            <Row>
              <h6 className='control-section'>All IPS Work Complete</h6>

              <Radio.Group
                onChange={handleCompleteProject}
                value={project?.ipsComplFlag}
                defaultValue={'N'}
                className='d-flex '
                disabled={!isFMPCreatorOrAdministrator() || !project?.showAllIpsComplete || project?.ipsComplFlag === 'Y'}
              >
                <Radio value={'Y'}>Yes</Radio>
                <Radio value={'N'}>No</Radio>
              </Radio.Group>
            </Row>
          </Col>
          {project?.ipsComplChangedDate && (
            <Col>{`${project?.ipsComplChangedBy}  ${formatDate(project?.ipsComplChangedDate)}`}</Col>
          )}
        </Row>
        <ConfirmDialog
          show={isModalOpen}
          title={confirmDialogDetails.title}
          handleCancel={handleCancel}
          submitFunctionArgs={confirmDialogDetails.submitFunctionArgs}
          handleSubmit={confirmDialogDetails.handleSubmit}
          confirmButtonName={confirmDialogDetails.confirmButtonName}
          cancelButtonName={'No,Cancel'}
        />
      </section>
    </>
  );
}

export default IpsWorkCompleteSection;
